import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME } from './constants';
export function PricingCard() {
  return <section id="offre" className="border-y-2 border-brand-orange/50 bg-brand-cream px-4 py-5" data-id="element-93" data-mp="1m4kz2fgqj34d">
      <div className="mx-auto max-w-2xl" data-id="element-94" data-mp="1i4itvwbsjrkc">
        <div className="mb-2 text-center" data-id="element-95" data-mp="2esp4czve9e6j">
          <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-orange sm:text-sm" data-id="element-96" data-mp="2esgrv936oavv">
            Offre spéciale de lancement
          </p>
          <h2 className="mb-0.5 font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-97" data-mp="2523xkp5kh3cj">
            {PRODUCT_NAME}
          </h2>
          <p className="mb-2 font-display text-[13px] font-semibold text-brand-ink sm:text-base" data-id="element-98" data-mp="20zhat2nr68m7">
            Système Complet 6-en-1 pour la Domotique
          </p>
          <a href={CHECKOUT_URL} className="block" aria-label={`Acheter ${PRODUCT_NAME}`} data-id="element-99" data-mp="2sryaf6pvyrws">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto mb-2 w-full max-w-[230px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-[260px]" data-id="element-100" data-mp="32ldnpasmjcxa" />
          </a>
        </div>

        <div className="mb-2 rounded-2xl border-4 border-brand-orange bg-white p-4 text-center shadow-2xl" data-id="element-101" data-mp="2xskfue1uzogz">
          <ul className="mb-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 text-[13px] font-semibold text-brand-ink sm:text-base" data-id="element-102" data-mp="2jt1kklu5c7m3">
            <li data-id="element-103" data-mp="2oql15sebgwh7">✅ 6 Modules Complets</li>
            <li data-id="element-104" data-mp="29wq6prewr9pj">✅ 5 Bonus Premium</li>
          </ul>
          <p className="mb-0.5 text-[13px] font-medium text-brand-muted" data-id="element-105" data-mp="29y1b9tg6glhp">
            Prix Habituel : <span className="line-through" data-id="element-106" data-mp="2ewuemt1r2w45">{PRICE_FULL}</span>
          </p>
          <p className="font-display text-base font-extrabold uppercase tracking-wide text-brand-orange sm:text-2xl" data-id="element-107" data-mp="84tknnv46hgi">
            🔥 AUJOURD’HUI SEULEMENT : {PRICE_TODAY}
          </p>
          <p className="mb-3 text-[11px] font-medium text-brand-muted" data-id="element-108" data-mp="bn98uvhkbfgd">
            Paiement sécurisé dans votre devise locale.
          </p>
          <CTAButton href={CHECKOUT_URL} data-id="element-109" data-mp="6phelutg3h90">🚀 OUI ! JE VEUX {PRODUCT_NAME}</CTAButton>
        </div>

        <TrustRow data-id="element-110" data-mp="1pv1rmhj430q" />
      </div>
    </section>;
}